import * as React from 'react';
import {Redirect, Route, RouteComponentProps} from 'react-router-dom';
import store from "./store";
import {useSelector} from "react-redux";
import {Routes, StaticRoutes} from "./routes";
import ErrorBoundary from "../components/common/ErrorBoundary/ErrorBoundary";

interface Props {
    Component: React.FC<RouteComponentProps> | any;
    path: string;
    exact?: boolean;
    uiRoute: string;
}


export const AuthRoute = ({Component, path, uiRoute, exact = false}: Props): JSX.Element => {
    const uiRoutes = useSelector((store: any) => store.auth.uiRoutes);

    const hasAccess = (): boolean => {
        if (uiRoute === StaticRoutes.FORBIDDEN || uiRoute === StaticRoutes.WELCOME) {
            return true;
        }

        if (uiRoutes.length === 0) {
            return false;
        }

        const pathFound = uiRoutes.find(route => route === uiRoute);
        return !!pathFound;
    };


    const renderComponent = (routeProps: RouteComponentProps) => {
        const user = store.getState().auth.user;
        const userHasRequiredPath = user ? hasAccess() : false;

        if (user && userHasRequiredPath) {
            return <Component {...routeProps}/>
        }

        if (user && (uiRoutes.length === 0 || (uiRoutes.length === 1 && uiRoutes[0] === Routes.BASE_PATH))) {
            return <Redirect to={{
                pathname: `${process.env.ENV_PREFIX}${StaticRoutes.WELCOME}`,
                state: {from: path}
            }}/>
        }

        return <Redirect to={{
            pathname: `${process.env.ENV_PREFIX}${StaticRoutes.FORBIDDEN}`,
            state: {form: path}
        }}/>

    }
    return (
        <ErrorBoundary key={path}>
            <Route
                path={path}
                exact={exact}
                render={(props: RouteComponentProps) => renderComponent(props)}
            />
        </ErrorBoundary>
    )
};



// WEBPACK FOOTER //
// ./app/config/AuthRoute.tsx